import { Field, RadioPills, Honeypot, SubmitButton, SuccessPanel, inputCls, useEnquiry } from "@/components/forms/fields";

const PROPERTY_TYPE = ["Owner Occupied", "Rental Property", "Business / Commercial", "Other"];
const EXISTING = ["Ducted Gas Heating", "Gas Space Heater", "Existing Ducted Reverse Cycle", "Existing Split System", "Electric Resistance Heating", "No Existing System", "Other / Not Sure"];
const INTERESTED_IN = ["Ducted Reverse Cycle", "Split System", "Multi-Head", "Not Sure"];

export default function VEUForm() {
  const { data, set, errors, status, submit, reset, formProps } = useEnquiry(
    "veu",
    ["full_name", "phone", "email", "address", "suburb", "postcode", "consent"],
    "/veu-rebates"
  );

  if (status === "success")
    return (
      <SuccessPanel
        testid="veu-form-success"
        title="Thank you — your eligibility check has been submitted."
        message="Our team will review your details and, where a VEU incentive may apply, confirm potential eligibility with a participating Accredited Provider before any installation."
        onReset={reset}
      />
    );

  return (
    <form onSubmit={submit} {...formProps} noValidate data-testid="veu-form" className="space-y-5">
      <Honeypot value={data.website || ""} onChange={(v) => set("website", v)} />
      <Field label="Full Name" required error={errors.full_name}>
        <input data-testid="veu-full-name" className={inputCls} value={data.full_name || ""} onChange={(e) => set("full_name", e.target.value)} autoComplete="name" />
      </Field>
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="Phone" required error={errors.phone}>
          <input data-testid="veu-phone" type="tel" className={inputCls} value={data.phone || ""} onChange={(e) => set("phone", e.target.value)} autoComplete="tel" />
        </Field>
        <Field label="Email" required error={errors.email}>
          <input data-testid="veu-email" type="email" className={inputCls} value={data.email || ""} onChange={(e) => set("email", e.target.value)} autoComplete="email" />
        </Field>
      </div>
      <Field label="Installation Address" required error={errors.address}>
        <input data-testid="veu-address" className={inputCls} value={data.address || ""} onChange={(e) => set("address", e.target.value)} autoComplete="street-address" />
      </Field>
      <div className="grid gap-5 sm:grid-cols-2">
        <Field label="Suburb" required error={errors.suburb}>
          <input data-testid="veu-suburb" className={inputCls} value={data.suburb || ""} onChange={(e) => set("suburb", e.target.value)} />
        </Field>
        <Field label="Postcode" required error={errors.postcode}>
          <input data-testid="veu-postcode" inputMode="numeric" className={inputCls} value={data.postcode || ""} onChange={(e) => set("postcode", e.target.value)} autoComplete="postal-code" />
        </Field>
      </div>
      <Field label="Property Type">
        <RadioPills testid="veu-property-type" options={PROPERTY_TYPE} value={data.property_type} onChange={(v) => set("property_type", v)} />
      </Field>
      <Field label="Existing System">
        <RadioPills testid="veu-existing" options={EXISTING} value={data.existing_system} onChange={(v) => set("existing_system", v)} />
      </Field>
      <Field label="Interested In">
        <RadioPills testid="veu-interested" options={INTERESTED_IN} value={data.interested_in} onChange={(v) => set("interested_in", v)} />
      </Field>
      <Field label="Number of Rooms">
        <select data-testid="veu-rooms" className={inputCls} value={data.rooms || ""} onChange={(e) => set("rooms", e.target.value)}>
          <option value="">Select…</option>
          <option>1</option><option>2</option><option>3</option><option>4</option>
          <option>5+</option><option>Whole home</option>
        </select>
      </Field>
      <Field label="Additional Information">
        <textarea data-testid="veu-additional-info" rows={4} className={inputCls} value={data.additional_info || ""} onChange={(e) => set("additional_info", e.target.value)} placeholder="Anything else we should know about your current system or property…" />
      </Field>
      <Field label="" error={errors.consent}>
        <span className="flex items-start gap-3">
          <input
            data-testid="veu-consent"
            type="checkbox"
            checked={!!data.consent}
            onChange={(e) => set("consent", e.target.checked ? "Yes" : "")}
            className="mt-0.5 h-5 w-5 shrink-0 rounded border-line accent-[#008CC4]"
          />
          <span className="text-xs leading-relaxed text-mutedblue">
            I understand that submitting this form does not guarantee VEU eligibility or a specific incentive amount.
          </span>
        </span>
      </Field>
      <SubmitButton status={status} testid="veu-submit-btn">Check Eligibility</SubmitButton>
    </form>
  );
}
